import { all, call } from 'redux-saga/effects';
import user from 'app/user/user.saga';

function* rootSaga() {
  yield all([call(user)]);
}

export default rootSaga;
